/**
 * toast — émetteur global minimaliste (sans dépendance), appelable de n'importe où.
 *
 *   import { toast } from '../lib/toast';
 *   toast.error("Échec de l'export");
 *   toast.success("Facture enregistrée");
 *   toast("Information");           // type info par défaut
 *
 * Un seul <Toaster /> (monté à la racine) s'abonne et affiche la pile.
 */
let listeners = [];
let items = [];
let seq = 0;

function emit() {
  for (const l of listeners) l(items);
}

function dismiss(id) {
  items = items.filter((t) => t.id !== id);
  emit();
}

function push(type, message, opts = {}) {
  if (message == null || message === '') return null;
  const id = ++seq;
  const duration = opts.duration != null ? opts.duration : 4200;
  // opts.action = { label, onClick } → rend un bouton (ex. « Annuler »)
  items = [...items, { id, type, message: String(message), action: opts.action || null }];
  emit();
  if (duration > 0) setTimeout(() => dismiss(id), duration);
  return id;
}

export const toast = Object.assign(
  (message, opts) => push('info', message, opts),
  {
    success: (m, o) => push('success', m, o),
    error: (m, o) => push('error', m, o),
    info: (m, o) => push('info', m, o),
    dismiss,
  }
);

export function subscribeToasts(fn) {
  listeners.push(fn);
  fn(items);
  return () => { listeners = listeners.filter((l) => l !== fn); };
}
